module.exports = __webpack_public_path__ + "img/transparent_folder.c7000c46.svg";